import React, { useEffect } from 'react';

import { PageLoading } from '@vyce/core/src/components/PageLoading';
import { FormConstructor } from './FormConstructor';
import { useFormRouteSegment } from './hooks/useFormRouteSegment';
import { useFormTemplateData } from './hooks/useFormTemplateData';
import { CenteredFormMessage } from './components/CenteredFormMessage';
import { FormDoc, User } from '../../types';

export const ExistingFormTemplate: React.FC<{ user: User; companyId: string }> = ({ user, companyId }) => {
  const { id: templateId } = useFormRouteSegment('templateId');
  const { template, loading, getTemplate } = useFormTemplateData({
    userId: user.uuid,
    companyId,
  });

  useEffect(() => {
    if (templateId) {
      getTemplate(templateId);
    }
  }, [templateId, getTemplate]);

  if (loading) {
    return <PageLoading />;
  }

  if (!template) {
    return <CenteredFormMessage>Form template not found</CenteredFormMessage>;
  }

  const formAsFormDoc: FormDoc = {
    id: template.id,
    title: template.title,
    description: template.description,
    questions: template.questions || [],
    signature: template.signature ?? false,
    clockInBlock: template.clockInBlock ?? false,
    createdBy: template.createdBy,
    status: 'draft',
    editors: [],
    createdAt: (template.createdAt as { _seconds: number } | Date) ?? new Date(),
    updatedAt: (template.updatedAt as { _seconds: number } | Date) ?? new Date(),
    questionCount: (template.questions || []).length,
    version: 1,
  };

  return (
    <FormConstructor form={formAsFormDoc} user={user} companyId={companyId} locations={[]} isTemplate />
  );
};
